export default __webpack_public_path__ + "static/media/welcome.a275559a.svg";